/*eslint-disable eqeqeq*/
import React from 'react';
import { Formik, Field, ErrorMessage } from 'formik'
// import './AreasForm.css'
import * as APIController from '../../../../api/APIController';
import * as yup from 'yup';

import Notification from '../../../../shared/components/notification/notification';
const AdminAreasForm = props => {
    const initialValues =
    {
        areaname: props.history.location.state.areaNameEdit,
        Shortcode: props.history.location.state.ShortcodeEdit,
        active: props.history.location.state.areaActiveEdit
    }
    const [isButtonValue, setButtonValue] = React.useState(false);
    const [IsLoading, setIsLoading] = React.useState(false);

    const wsAddEditArea = (ID, Name, ShortCode, IsActive) => {
        setIsLoading(true)
        APIController.AddEditArea(ID, Name, ShortCode, IsActive)
            .then((response) => {
                setIsLoading(false)
                if (response.error == null) {
                    if (isButtonValue === true && response.object.status == 1) {
                        props.history.replace({ pathname: '/resource/areas', state: { showMessage: response.object.message } })
                    } else if (response.object.status == 1) {
                        handleNotification(response.object.message);
                    } else {
                        handleNotification(response.object.message, true);
                    }
                }
                else if (response.error.message && response.error.message.length > 0) {
                    handleNotification(response.error.message, true);
                }
            })
    }

    const [message, setMessage] = React.useState("");
    const [showNotification, setShowNotification] = React.useState(false);
    const [isError, setIsError] = React.useState(false);

    const handleNotification = (message, isError) => {
        setMessage(message)
        setShowNotification(true)
        setIsError(isError)

        setTimeout(() => {
            handleClearNotification();
        }, 4000)
    }

    const handleClearNotification = () => {
        setMessage('')
        setShowNotification(false)
        setIsError(false)
    }
    return (
        <>
            <section className="content-right-main">
                {props.history.location.state.areaIdEdit == 0 ? <h1>Add Area</h1> : <h1>Edit Area</h1>}
                <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={validateAreasForm}
                    validateOnMount={false}
                    onSubmit={(values) => {
                        wsAddEditArea(props.history.location.state.areaIdEdit, values.areaname, values.Shortcode, values.active)
                        if (isButtonValue === false) {
                            values.areaname = "";
                            values.Shortcode = "";
                            values.active = 1;
                        }
                    }} >
                    {({
                        values,
                        handleSubmit,
                        setFieldValue,
                        errors,
                        touched,
                    }) => {
                        return (
                            <div className="form-main">
                                <form onSubmit={handleSubmit}>
                                    {/* <div className="form_field"> */}
                                    <div
                                        className={`form_field ${
                                            errors &&
                                                touched.areaname &&
                                                errors.areaname &&
                                                errors.areaname !== ''
                                                ? 'error'
                                                : ''
                                            }`}>
                                        <div className="field-left">
                                            <label>Area</label>
                                        </div>
                                        <div className="field-right">
                                            <Field type="text" placeholder="Enter Area" name="areaname" value={values.areaname} maxLength="50" />
                                            {errors &&
                                                touched.areaname &&
                                                errors.areaname &&
                                                errors.areaname !==
                                                '' && (
                                                    <span className='error-msg'>
                                                        <ErrorMessage
                                                            name='areaname'
                                                            render={(
                                                                err
                                                            ) => {
                                                                return err;
                                                            }}
                                                        />
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                    <div
                                        className={`form_field ${
                                            errors &&
                                                touched.Shortcode &&
                                                errors.Shortcode &&
                                                errors.Shortcode !== ''
                                                ? 'error'
                                                : ''
                                            }`}>
                                        <div className="field-left">
                                            <label>Short Code</label>
                                        </div>
                                        <div className="field-right">
                                            <Field type="text" placeholder="Enter Short code" name="Shortcode" value={values.Shortcode} maxLength="50" />
                                            {errors &&
                                                touched.Shortcode &&
                                                errors.Shortcode &&
                                                errors.Shortcode !==
                                                '' && (
                                                    <span className='error-msg'>
                                                        <ErrorMessage
                                                            name='Shortcode'
                                                            render={(
                                                                err
                                                            ) => {
                                                                return err;
                                                            }}
                                                        />
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                    <div className="form_field">
                                        <div className="field-left">
                                            <label>Is Active ?</label>
                                        </div>
                                        <div className="field-right">
                                            <div className="custom-radio">
                                                <input type="radio" name="active" id="yes-text"
                                                    defaultValue={values.active}
                                                    defaultChecked={values.active != 0 ? true : false}
                                                    // defaultChecked={values.active != false ? true : false}
                                                    // onClick={(e) => setFieldValue('active', true)} />
                                                    onClick={(e) => setFieldValue('active', 1)} />
                                                <label htmlFor="yes-text">Yes</label>
                                            </div>
                                            <div className="custom-radio">
                                                <input type="radio" name="active" id="no-text"
                                                    defaultValue={values.active}
                                                    defaultChecked={values.active == 0 ? true : false}
                                                    onClick={(e) => setFieldValue('active', 0)} />
                                                {/* // defaultChecked={values.active == false ? true : false}
                                                    // onClick={(e) => setFieldValue('active', false)} /> */}
                                                <label htmlFor="no-text">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    <Notification
                                        isError={isError}
                                        message={message}
                                        showNotification={showNotification}
                                        clearNotification={handleClearNotification.bind(this)}
                                        closeNotification={handleClearNotification.bind(this)}
                                    />
                                    <div className="form-submit">
                                        <div className={IsLoading ? "button-field disable-btn" : "button-field"}>
                                            <input type="submit" value={IsLoading ? "Saving..." : "save"} name="save" onClick={() => setButtonValue(true)} />
                                        </div>
                                        {props.history.location.state.areaIdEdit == 0 ?
                                            <div className={IsLoading ? "button-field disable-btn" : "button-field"}>
                                                <input type="submit" value={IsLoading ? "Saving..." : "save & add new"} name="save & add new" onClick={() => setButtonValue(false)} />
                                            </div> : null}
                                        <div className="button-field">
                                            <input type="button" value="close" name="close" onClick={() => props.history.goBack()} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )
                    }}
                </Formik>
            </section>
        </>
    )
}
const validateAreasForm = yup.object().shape({
    areaname: yup.string().required('Area is required'),
    Shortcode: yup.string().required('Short code is required'),
});


export default AdminAreasForm;